var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: "100%",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5007 9.32378C29.356 8.32031 27.0628 7.59104 24.6652 7.17578C24.3708 7.70813 24.0268 8.42414 23.7896 8.99373C21.241 8.61044 18.7158 8.61044 16.214 8.99373C15.9769 8.42414 15.6251 7.70813 15.328 7.17578C12.9279 7.59104 10.632 8.32299 8.4873 9.32909C4.16137 15.8661 2.98868 22.2408 3.57502 28.525C6.44421 30.6676 9.2248 31.9692 11.9585 32.8209C12.6334 31.892 13.2354 30.9045 13.754 29.8638C12.7663 29.4885 11.8203 29.0254 10.9265 28.4878C11.1636 28.3121 11.3956 28.1284 11.6197 27.9394C17.0714 30.4893 22.9948 30.4893 28.3814 27.9394C28.6081 28.1284 28.84 28.3121 29.0745 28.4878C28.1781 29.028 27.2295 29.4912 26.2419 29.8665C26.7605 30.9045 27.3598 31.8947 28.0374 32.8236C30.7737 31.9719 33.5568 30.6703 36.426 28.525C37.114 21.24 35.2508 14.9239 31.5007 9.32378ZM14.4967 24.6603C12.8601 24.6603 11.518 23.1325 11.518 21.272C11.518 19.4115 12.8315 17.881 14.4967 17.881C16.1619 17.881 17.504 19.4088 17.4753 21.272C17.4779 23.1325 16.1619 24.6603 14.4967 24.6603ZM25.5044 24.6603C23.8678 24.6603 22.5257 23.1325 22.5257 21.272C22.5257 19.4115 23.8391 17.881 25.5044 17.881C27.1696 17.881 28.5117 19.4088 28.483 21.272C28.483 23.1325 27.1696 24.6603 25.5044 24.6603Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.7391737a2fdda73caaccdce351c4afc0.svg";
export { ForwardRef as ReactComponent };